import { z } from "zod";

export const Unit = z.enum(["SINGLES", "LITRESOFPUREALCOHOL", "HECTOLITRES"]);
